import axios, { AxiosResponse } from 'axios';

import { EStavPozadavku } from 'enums/specialniSluzby/stavPozadavku';
import { ETypTransakce } from 'enums/specialniSluzby/typTransakce';

import { EKontrolaPocet } from './ueZaevidovani';

export interface IPolozky {
    idpolozky: number;
    pocetcp: number;
    ucet: string;
    idnabyvatele: string;
    koducastnika: string;
    cislozastavnismlouvy: string;
    poznamka: string;
    zdrojdat: string;
    zpusobporizeni: string;
    typtransakce: ETypTransakce;
    upozorneni: string;
    idvcdcp: string;
    stav: EStavPozadavku;
    idvisb: string;
    uzivatel: string;
    meznidatumprozruseni: string;
    lzeevidovatod: string;
}

export interface IZruseniGet {
    polozky: IPolozky[];
    offset: number;
    limit: number;
    count: number;
    order: string;
    pocetcp: number;
    pocetuctu: number;
}

interface IDataZruseniGet {
    id?: number | string;
    idpolozky?: number | string;
    ucet?: string;
    idnabyvatele?: string;
    koducastnika?: string;
    zdrojdat?: string;
    zpusobporizeni?: string;
    idvcdcp?: string;
    typtransackce?: ETypTransakce;
    stav?: string;
    offset?: number;
    limit?: number;
    order?: string;
}

interface IDataZruseniDelete {
    id?: number | string;
    idpolozky?: number | string;
    ucet?: string;
    idnabyvatele?: string;
    koducastnika?: string;
    zdrojdat?: string;
    zpusobporizeni?: string;
    idvcdcp?: string;
    typtransakce?: ETypTransakce;
    stav?: string;
}

/* Vrátí seznam položek pro zrušení */
export const ueZruseniGet = (id: number, data: IDataZruseniGet) => {
    return axios({
        method: 'GET',
        url: `/UE/${id}/vymazani`,
        params: {
            ...data
        }
    }).then((resp: AxiosResponse<IZruseniGet>) => resp.data);
};
/* Zrušení položky požadavku */
export const ueZruseniDelete = (id: number, data?: IDataZruseniDelete) => {
    return axios({
        method: 'DELETE',
        url: `/UE/${id}/vymazani`,
        params: {
            ...data
        }
    }).then((resp: AxiosResponse) => resp.data);
};

export const ueZruseni = (id: number, data?: IDataZruseniDelete) => {
    return axios({
        method: 'DELETE',
        url: `/UE/${id}/zruseni`,
        params: {
            ...data
        }
    }).then((resp: AxiosResponse) => resp.data);
};

export interface IPolozkyDLT {
    idpolozky: number;
    pocetcp: number;
    ucet: string;
    cislozastavnismlouvy: string;
    poznamka: string;
    zpusobporizeni: string;
    upozorneni: string;
    stav: string;
    meznidatumprozruseni: string;
    lzeevidovatod: string;
    uzivatel: string;
    sankce: boolean;
}
export interface IZruseniGetDLT {
    polozky: IPolozkyDLT[];
    count: number;
    order: string;
    limit: number;
    offset: number;
    pocetcp: number;
    pocetuctu: number;
    kontrolapocet: EKontrolaPocet;
}

interface IDataZruseniGetDLT {
    id?: number | string;
    idpolozky?: number | string;
    ucet?: string;
    zpusobpor?: string;
    stav?: string;
    sankce?: boolean;
    pocetcp?: string;
    rliv?: string;
    offset?: number;
    limit?: number;
    order?: string;
}

interface IDataZruseniDeleteDLT {
    id?: number | string;
    idpolozky?: number | string;
    ucet?: string;
    zpusobpor?: string;
    stav?: string;
    sankce?: boolean;
    pocetcp?: string;
    rliv?: string;
}

/* Vrátí seznam položek pro zrušení */
export const ueZruseniGetDLT = (id: number, data: IDataZruseniGetDLT) => {
    return axios({
        method: 'GET',
        url: `/UED/${id}/vymazani`,
        params: {
            ...data
        }
    }).then((resp: AxiosResponse<IZruseniGetDLT>) => resp.data);
};
/* Zrušení položky požadavku */
export const ueZruseniDeleteDLT = (id: number, data?: IDataZruseniDeleteDLT) => {
    return axios({
        method: 'DELETE',
        url: `/UED/${id}/vymazani`,
        params: {
            ...data
        }
    }).then((resp: AxiosResponse) => resp.data);
};

export const ueZruseniDLT = (id: number, data?: IDataZruseniDeleteDLT) => {
    return axios({
        method: 'DELETE',
        url: `/UED/${id}/zruseni`,
        params: {
            ...data
        }
    }).then((resp: AxiosResponse) => resp.data);
};

export const ueZruseniSingleDLT = (id: number) => {
    return axios({
        method: 'PUT',
        url: `/UED/${id}/zruseni`
    }).then((resp: AxiosResponse) => resp.data);
};
export const uePotvrzeniSingleDLT = (id: number) => {
    return axios({
        method: 'PUT',
        url: `/UED/${id}/potvrzeni`
    }).then((resp: AxiosResponse) => resp.data);
};
